/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BudgetDto } from '../../models/budget-dto';

export interface GetBudget$Params {
  id: string;
}

export function getBudget(http: HttpClient, rootUrl: string, params: GetBudget$Params, context?: HttpContext): Observable<StrictHttpResponse<BudgetDto>> {
  const rb = new RequestBuilder(rootUrl, getBudget.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BudgetDto>;
    })
  );
}

getBudget.PATH = '/v0/budgets/{id}';
